module.exports = __webpack_public_path__ + "img/speaker_with_gradient.6cd90f7c.png";